import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=45a3a857&scoped=true&"
import script from "./AdminMenu.vue?vue&type=script&lang=js&"
export * from "./AdminMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&id=45a3a857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3a857",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a3a857')) {
      api.createRecord('45a3a857', component.options)
    } else {
      api.reload('45a3a857', component.options)
    }
    module.hot.accept("./AdminMenu.vue?vue&type=template&id=45a3a857&scoped=true&", function () {
      api.rerender('45a3a857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/AdminMenu.vue"
export default component.exports